import React, { useEffect, useState, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
  Button,
  MenuItem,
  TextField,
  Toolbar,
  Typography,
  Grid,
  Paper,
  InputLabel,
  Select,
  FormControl,
  IconButton,
  Popover,
  Box,
  Snackbar
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import { Skeleton, Alert } from "@material-ui/lab";
import fileDownload from "js-file-download";
import GetAppIcon from "@material-ui/icons/GetApp";
import RefreshIcon from "@material-ui/icons/Refresh";
import TablePaginationActions from "../utils/TablePaginationActions";
import ServicesContext from "../../contexts/servicesContext";
import PopupState, { bindTrigger, bindPopover } from "material-ui-popup-state";

const useStyles = makeStyles((theme) => ({
  seeMore: {
    marginTop: theme.spacing(3),
  },
  toolbar: {
    display: "flex",
    flexDirection: "row",
  },
  title: {
    flex: "1 1 100%",
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  formControl: {
    minWidth: "100%",
  },
  fioInput: {
    minWidth: "100%",
    height: "100%",
    "& .MuiInputBase-root": {
      height: "100%",
    },
  },
  buttonGroup: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    "& button": {
      marginRight: "10px",
    },
  },
}));

function AetRequestList() {
  const rowsPerPage = 20;
  const [currentPage, setCurrentPage] = useState(0);
  const [regions, setRegions] = useState();
  const [dates, setDates] = useState();
  const [regionId, setRegionId] = useState("");
  const [dateId, setDateId] = useState("");
  const dayjs = require("dayjs");
  const [loading, setLoading] = useState(true);
  const [requests, setRequests] = useState([]);
  const [requestsCount, setRequestsCount] = useState(0);
  const [forAstana, setForAstana] = useState();

  const [searchQuery, setSearchQuery] = useState("");
  const [open, setOpen] = useState(true);
  const [showError, setShowError] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [refreshPage, setRefreshPage] = useState(false);
  const [showErrorEditNotif, setShowErrorEditNotif] = useState(false);

  const classes = useStyles();
  const services = useContext(ServicesContext);

  const resetFilter = () => {
    setRegionId("");
    setDateId("");
    setSearchQuery("");
    setCurrentPage(0);
  };

  useEffect(() => {
    setLoading(true);
    services.aet.getAllRegions().then((response) => {
      setRegions(response.data);
    });
    services.aet.getAllDates().then((response) => {
      setDates(response.data);
    });
    const debouncedSearch = setTimeout(() => {
      if (regionId === 1) {
        setForAstana(true);
      } else {
        setForAstana(false);
      }

      services.aet
        .getRequestsByFilter({
          applicationYear: localStorage.getItem("AdmissionOfYear"),
          regionId: regionId,
          dateId: dateId,
          page: currentPage,
          keyword: searchQuery.replace(/\s/g, ""),
        })
        .then((response) =>
          setRequests(() => {
            const { list, total_number } = response.data;
            setRequestsCount(total_number);
            setLoading(false);
            return list;
          })
        );
    }, 1500);

    return () => clearInterval(debouncedSearch);
  }, [
    regionId,
    dateId,
    searchQuery,
    currentPage,
    services,
    localStorage.getItem("AdmissionOfYear"),
    refreshPage
  ]);

  function handleClose(event, reason) {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
    setShowError(false);
    setShowSuccess(false);
  }

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleSearchQueryChange = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(0);
  };

  const handleDeleteDate = (id) => {
    if (id !== null && id !== undefined) {
      services.aet
        .cancelRequestForMarketing(id)
        .then(() => {
          setShowSuccess(true);
          setOpen(true);
          setRefreshPage(!refreshPage);
        })
        .catch(() => {
          setShowErrorEditNotif(true);
          setOpen(true);
          setRefreshPage(!refreshPage);
        });
    }
  };

  const getExcelFile = () => {
    services.aet
      .getExcelRequests({
        applicationYear: localStorage.getItem("AdmissionOfYear"),
        regionId: regionId,
        dateId: dateId,
        keyword: searchQuery.trim(),
      })
      .then((response) => fileDownload(response.data, "AET.xlsx"));
  };

  const getCsvFile = () => {
    services.aet
      .getCsvRequests({
        applicationYear: localStorage.getItem("AdmissionOfYear"),
        regionId: regionId,
        dateId: dateId,
        keyword: searchQuery.trim(),
      })
      .then((response) => {
        const csvData = new Blob([response.data], {
          type: "text/csv;charset=utf-8;",
        });
        fileDownload(csvData, "AET.csv");
      });
  };

  const handleChooseRegion = (event) => {
    setRegionId(event.target.value);
    setCurrentPage(0);
  };

  const handleChooseDate = (event) => {
    setDateId(event.target.value);
    setCurrentPage(0);
  };
  return (
    <Paper className={classes.paper}>
      <Toolbar>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography
              className={classes.title}
              variant="h6"
              id="tableTitle"
              component="div"
            >
              Заявки на AET
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item lg={6} xs={12}>
                <TextField
                  placeholder="Введите ваш запрос (ФИО или ИИН)"
                  value={searchQuery}
                  onChange={(event) => handleSearchQueryChange(event)}
                  className={classes.fioInput}
                />
              </Grid>
              <Grid item lg={3} xs={6}>
                <FormControl className={classes.formControl}>
                  <InputLabel id="region-select">По региону</InputLabel>
                  <Select
                    labelId="region-select"
                    id="region-select-standard"
                    value={regionId}
                    onChange={handleChooseRegion}
                    label="По региону"
                  >
                    <MenuItem value="none">
                      <em>-</em>
                    </MenuItem>
                    <MenuItem value={1}>Астана</MenuItem>
                    <MenuItem value={2}>Другие регионы</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item lg={3} xs={6}>
                <FormControl className={classes.formControl}>
                  <InputLabel id="date-select">По дате</InputLabel>
                  <Select
                    labelId="date-select"
                    id="date-select-standard"
                    value={dateId}
                    onChange={handleChooseDate}
                    label="По дате"
                  >
                    <MenuItem value="none">
                      <em>-</em>
                    </MenuItem>
                    {dates
                      ?.filter((date) => date.forAstana === forAstana)
                      .map((date) => (
                        <MenuItem value={date.id} key={date.id}>
                          {dayjs(date.date).format("DD-MM-YYYY HH:mm")}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item lg={6} xs={6}>
                <div className={classes.buttonGroup}>
                  <Button
                    variant="outlined"
                    onClick={resetFilter}
                    size="small"
                    startIcon={<RefreshIcon />}
                  >
                    Сбросить фильтр
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={getExcelFile}
                    color="primary"
                    startIcon={<GetAppIcon />}
                    size="small"
                  >
                    Скачать в excel
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={getCsvFile}
                    color="primary"
                    startIcon={<GetAppIcon />}
                    size="small"
                  >
                    Скачать в csv
                  </Button>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Toolbar>

      <Table aria-label="custom pagination table">
        <TableHead>
          <TableRow>
            <TableCell>ФИО</TableCell>
            <TableCell>ИИН</TableCell>
            <TableCell>Номер телефона</TableCell>
            <TableCell>Эл. почта</TableCell>
            <TableCell>Регион</TableCell>
            <TableCell>Дата и время</TableCell>
            <TableCell>Международные сертификаты по английскому языку (IELTS, TOEFL IBT, TOEFL ITP, APTIS,
                                    InterPress, AITU iQyn,)</TableCell>
            <TableCell>Сертификат олимпиады (AITU iCode, AITU Open,
                            Жаутыковской или Евразийской олимпиады) </TableCell>
            <TableCell>Дата записи</TableCell>
            <TableCell align="right">Действие</TableCell>
          </TableRow>
        </TableHead>

        {loading ? (
          <TableBody>
            {[...Array(10)].map((x, i) => {
              return (
                <TableRow key={i}>
                  <TableCell component="th" scope="row">
                    <Skeleton variant="text" />
                  </TableCell>
                  <TableCell component="th" scope="row">
                    <Skeleton variant="text" />
                  </TableCell>
                  <TableCell component="th" scope="row">
                    <Skeleton variant="text" />
                  </TableCell>
                  <TableCell component="th" scope="row">
                    <Skeleton variant="text" />
                  </TableCell>
                  <TableCell component="th" scope="row">
                    <Skeleton variant="text" />
                  </TableCell>
                  <TableCell component="th" scope="row">
                    <Skeleton variant="text" />
                  </TableCell>
                  <TableCell component="th" scope="row">
                    <Skeleton variant="text" />
                  </TableCell>
                  <TableCell component="th" scope="row">
                    <Skeleton variant="text" />
                  </TableCell>
                  <TableCell component="th" scope="row">
                    <Skeleton variant="text" />
                  </TableCell>
                  <TableCell component="th" scope="row" align="right">
                    <Skeleton variant="text" />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        ) : (
          <TableBody>
            {requests?.map((request) => (
              <TableRow key={request?.id}>
                <TableCell component="th" scope="row">
                  {request?.surname +
                    " " +
                    request?.name +
                    " " +
                    (request?.patronymic ? request?.patronymic : "")}
                </TableCell>
                <TableCell component="th" scope="row">
                  {request?.iin}
                </TableCell>
                <TableCell component="th" scope="row">
                  {request?.phoneNumber}
                </TableCell>
                <TableCell component="th" scope="row">
                  {request?.email}
                </TableCell>
                <TableCell component="th" scope="row">
                  {request?.region}
                </TableCell>
                <TableCell component="th" scope="row">
                  {dayjs(request?.requestDate).format("DD-MM-YYYY HH:mm")}
                </TableCell>
                <TableCell component="th" scope="row">
                  {request?.englishCertificate ? "Есть" : "Нет"}
                </TableCell>
                <TableCell component="th" scope="row">
                  {request?.olympiadCertificate ? "Есть" : "Нет"}
                </TableCell>
                <TableCell component="th" scope="row">
                  {request?.created
                    ? dayjs(request?.created).format("DD-MM-YYYY HH:mm")
                    : "-"}
                </TableCell>
                <TableCell component="th" scope="row" align="right">
                  <PopupState variant="popover" popupId="demo-popup-popover">
                    {(popupState) => (
                      <>
                        <IconButton
                          aria-label="delete"
                          size="small"
                          className={classes.button}
                          {...bindTrigger(popupState)}
                        >
                          <DeleteIcon />
                        </IconButton>
                        <Popover
                          {...bindPopover(popupState)}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "center",
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "center",
                          }}
                        >
                          <Box p={2}>
                            <Typography>
                              Вы уверены, что хотите удалить?
                            </Typography>
                            <Button
                              variant="outlined"
                              className={classes.button}
                              size="small"
                              onClick={() => {
                                popupState.close();
                                handleDeleteDate(request?.id);
                              }}
                            >
                              да
                            </Button>
                            <Button
                              variant="outlined"
                              className={classes.button}
                              size="small"
                              onClick={popupState.close}
                            >
                              нет
                            </Button>
                          </Box>
                        </Popover>
                      </>
                    )}
                  </PopupState>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        )}
      </Table>
      <TablePagination
        count={requestsCount}
        rowsPerPage={rowsPerPage}
        page={currentPage}
        component="div"
        rowsPerPageOptions={[]}
        onChangePage={handleChangePage}
        ActionsComponent={TablePaginationActions}
      />
      {showError && (
        <div>
          <Snackbar
            open={open}
            autoHideDuration={3000}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            ContentProps={{
              "aria-describedby": "message-id",
            }}
          >
            <Alert
              onClose={handleClose}
              severity="warning"
              variant="filled"
              elevation={6}
              sx={{ width: "100%" }}
            >
              Не удалось удалить!
            </Alert>
          </Snackbar>
        </div>
      )}
      {showSuccess && (
        <div>
          <Snackbar
            open={open}
            autoHideDuration={3000}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            ContentProps={{
              "aria-describedby": "message-id",
            }}
          >
            <Alert
              onClose={handleClose}
              severity="success"
              variant="filled"
              elevation={6}
              sx={{ width: "100%" }}
            >
              Успешно удален!
            </Alert>
          </Snackbar>
        </div>
      )}
    </Paper>
  );
}

export default AetRequestList;